import { merge } from 'lodash';

import { EditableImage, isFile, Image } from 'wui/ImageViewer';
import {
  IExtendedEvent,
  IGroupMembersEvent,
} from '@wix/social-groups-serverless/dist/events/types';

import { IEventForm } from './common/EventForm';

export function getInitialValues(): IEventForm {
  const start = new Date(Date.now());
  start.setDate(start.getDate() + 14);
  start.setHours(19, 0, 0, 0);

  const end = new Date(start.getTime());
  end.setHours(23, 0, 0, 0);

  return {
    name: '',
    startDate: formatDate(start),
    endDate: formatDate(end),
    location: '',
    duration: end.getTime() - start.getTime(),
    cover: {},
    teaser: '',
  };
}

export function toFormValues(event?: IExtendedEvent): IEventForm {
  const initialValues = getInitialValues();

  const startDate = new Date(
    `${event?.dateAndTimeSettings?.formatted?.startDate} ${event?.dateAndTimeSettings?.formatted?.startTime}`,
  );

  const endDate = new Date(
    `${event?.dateAndTimeSettings?.formatted?.endDate} ${event?.dateAndTimeSettings?.formatted?.endTime}`,
  );

  return merge(initialValues, {
    name: event?.title,
    startDate: isValidDate(startDate) ? formatDate(startDate) : undefined,
    endDate: isValidDate(endDate) ? formatDate(endDate) : undefined,
    location: event?.location?.name,
    cover: event?.mainImage?.id
      ? {
          image: {
            mediaId: event?.mainImage?.id,
            width: event?.mainImage?.width,
            height: event?.mainImage?.height,
          },
        }
      : undefined,
    teaser: event?.shortDescription,
  });
}

function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d as any);
}

function formatDate(date: Date) {
  const dateParts = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
    .map((n) => n.toString().padStart(2, '0'))
    .join('-');
  const timeParts = [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((n) => n.toString().padStart(2, '0'))
    .join(':');
  return dateParts + 'T' + timeParts;
}

export function toEventImage(
  editableImage?: EditableImage,
): IGroupMembersEvent['image'] {
  if (isFile(editableImage) || !editableImage?.image) {
    return;
  }
  return {
    id: (editableImage?.image as Image).mediaId || '',
    width: (editableImage?.image as Image).width || 0,
    height: (editableImage?.image as Image).height || 0,
  };
}

export function getDeviceTimeZoneId() {
  const defaultTimeZoneId = 'UTC';

  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimeZoneId
    );
  } catch (e) {
    return defaultTimeZoneId;
  }
}
